<!-- src/app/meter/components/meter-list/meter-health/meter-health.component.html -->

<div class="health-container">
    <div class="table-container">
        <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="40" class="spinner"></mat-progress-spinner>

        <table mat-table [dataSource]="meters" *ngIf="!loading">
            <ng-container matColumnDef="nodeId">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_meter_id' | translate }}</th>
                <td mat-cell *matCellDef="let meter">{{ meter.nodeId }}</td>
            </ng-container>

            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_address' | translate }}</th>
                <td mat-cell *matCellDef="let meter">{{ formatAddress(meter) }}</td>
            </ng-container>

            <ng-container matColumnDef="users">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_users' | translate }}</th>
                <td mat-cell *matCellDef="let meter">{{ meter.users.length }}</td>
            </ng-container>

            <ng-container matColumnDef="lastMeterReadAt">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_last_reading' | translate }}</th>
                <td mat-cell *matCellDef="let meter">
                    {{ meter.lastMeterReadAt ? (meter.lastMeterReadAt | date:'mediumDate') : ('meter.manage.never' | translate) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="daysSilent">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_days_silent' | translate }}</th>
                <td mat-cell *matCellDef="let meter" class="days-silent">
                    {{ getDaysSilent(meter) }}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div *ngIf="!loading && meters.length === 0" class="no-results">
            <p>{{ 'meter.manage.no_unhealthy' | translate }}</p>
        </div>
    </div>

    <mat-paginator
        [length]="total"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[10, 20, 50]"
        (page)="onPageChange($event)"
        showFirstLastButtons>
    </mat-paginator>
</div>
